module.exports = __webpack_public_path__ + "36c131452036ecd9aee12af3c918d1f1.jpg";